import React from "react";

/**
 * @component ViewTimelineIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ViewTimelineIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ViewTimelineIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ViewTimelineIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M10 17h10a1 1 0 010 2H10a1 1 0 010-2zm-3-6h10a1 1 0 010 2H7a1 1 0 010-2zM4 5h10a1 1 0 010 2H4a1 1 0 110-2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ViewTimelineIcon.displayName = "ViewTimelineIcon";
export default ViewTimelineIcon;
